<template>
    <div>
        <b-card v-show="mostrarTabela" no-body>
            <b-card-header>
                <span class="h5">Certidões</span>
            </b-card-header>
            <b-card-body>
                <app-tabela
                    idTabela="tblCertidoes"
                    :itens="certidoes"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                >
                    <template slot="cndSituacao" slot-scope="data">
                        <app-status
                            :status="data.cndSituacao ? data.cndSituacao.toUpperCase() : 'NÃO ATUALIZADO'"
                        ></app-status>
                    </template>
                    <template slot="fgtsSituacao" slot-scope="data">
                        <app-status
                            :status="data.fgtsSituacao ? data.fgtsSituacao.toUpperCase() : 'NÃO ATUALIZADO'"
                        ></app-status>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <span class="text-primary" v-if="$temAcessoView('CERT-01')">
                            <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhar"
                                @click.stop="detalharCertidoes(data.codCfo)"
                            ></i>
                        </span>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
import CertidoesServicos from './../rm/CertidoesServicos'

export default {
	components: {},
	data() {
		return {
			certidoes: [],
			campos: [
				{
					key: 'nome',
					label: 'Fornecedor',
					sortable: true,
					filterable: true
				},
				{
					key: 'cgcCfo',
					label: 'CNPJ',
					sortable: true,
					filterable: true,
					tdClass: 'text-center'
				},
				{
					key: 'cndAtualizacao',
					label: 'Atualização CND',
					tdClass: 'text-center',
					type: 'datetime'
				},
				{
					key: 'cndSituacao',
					label: 'Status CND',
					tdClass: 'text-center'
				},
				{
					key: 'cndValidade',
					label: 'Validade CND',
					tdClass: 'text-center',
					type: 'date'
				},
				{
					key: 'fgtsAtualizacao',
					label: 'Atualização FGTS',
					tdClass: 'text-center',
					type: 'datetime'
				},
				{
					key: 'fgtsSituacao',
					label: 'Status FGTS',
					tdClass: 'text-center',
					type: 'status'
				},
				{
					key: 'fgtsValidadeFim',
					label: 'Validade FGTS',
					tdClass: 'text-center',
					type: 'date'
				},
				{
					key: 'acoes',
					label: 'Ações'
				}
			],
			itensPorPagina: 10
		}
	},
	methods: {
		obterCertidoes() {
			this.$store.dispatch('addRequest')
			CertidoesServicos.obterTodas().then(response => {
				if (response) {
					if (response.success) {
						this.certidoes = response.data
					} else {
						this.$toast.error(response.errors, 'ERROR', this.error)
					}
				}
				this.$store.dispatch('removeRequest')
			})
		},

		detalharCertidoes(codCfo) {
			this.$router.push({
				name: 'Certidoes_Detalhar',
				params: {
					codCfo: codCfo
				}
			})
		}
	},

	created() {
		this.obterCertidoes()
	},

	computed: {
		mostrarTabela() {
			return this.$route.name === 'Certidoes'
		}
	},

	watch: {
		$route(to, from) {
			if (to.name === 'Certidoes') {
				if (this.$store.getters.recarregar) {
					this.obterCertidoes()
					this.$store.dispatch('setRecarregar', false)
				}
			}
		}
	}
}
</script>

